module.exports = __webpack_public_path__ + "d1896e346af9e5362329128c91921252.fbx";